import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import warrantyIcon from "../../../../img/icons/mattress-match/10-year-warranty.svg";
import freeDeliveryIcon from "../../../../img/icons/mattress-match/free-delivery.svg";
import moonIcon from "../../../../img/icons/mattress-match/moon.svg";

import styles from "./index.module.scss";

export const ValueProps = (props: Immutable<{ stacked?: boolean }>) => {
    function getWarrantyVP() {
        return (
            <li>
                <SVG aria-hidden="true" src={warrantyIcon} />
                {t`10-Year Warranty`}
            </li>
        );
    }
    function getTrialVP() {
        return (
            <li>
                <SVG aria-hidden="true" src={moonIcon} />
                {t`90-Night Trial`}
            </li>
        );
    }

    function getDeliveryVP() {
        return (
            <li>
                <SVG aria-hidden="true" src={freeDeliveryIcon} />
                {t`Free Delivery`}
            </li>
        );
    }

    const classes = classNames({
        [styles.root]: true,
        [styles.stacked]: props.stacked,
    });
    return (
        <ul className={classes}>
            {getTrialVP()}
            {getWarrantyVP()}
            {getDeliveryVP()}
        </ul>
    );
};
